/**
 * Types pour les rôles sur les opportunités
 */

export type OpportunityRoleType =
  | 'coordinator'
  | 'contributor'
  | 'reviewer'
  | 'observer'
  | 'lot_manager';

export interface NotificationPreferences {
  email: boolean;
  push: boolean;
  milestones: boolean;
  tasks: boolean;
  comments: boolean;
}

export interface OpportunityRole {
  id: number;
  opportunityId: number;
  lotId?: number;
  userId: number;
  role: OpportunityRoleType;
  roleLabel: string;
  notificationPrefs: NotificationPreferences;
  notes?: string;
  canEdit: boolean;
  isReadOnly: boolean;
  isActive: boolean;
  createdAt: string;
  userName?: string;
  userEmail?: string;
}

export interface CreateRoleDto {
  opportunityId: number;
  lotId?: number;
  userId: number;
  role: OpportunityRoleType;
  notificationPrefs?: NotificationPreferences;
  notes?: string;
}

export interface UpdateRoleDto {
  lotId?: number | null;
  role?: OpportunityRoleType;
  notificationPrefs?: NotificationPreferences;
  notes?: string | null;
}

/**
 * Configuration d'affichage des rôles
 */
export const ROLE_CONFIG: Record<
  OpportunityRoleType,
  { label: string; description: string; color: string; bgColor: string }
> = {
  coordinator: {
    label: 'Coordinateur',
    description: 'Responsable principal de l\'opportunité',
    color: 'text-purple-700',
    bgColor: 'bg-purple-100',
  },
  contributor: {
    label: 'Contributeur',
    description: 'Participe à la rédaction de la réponse',
    color: 'text-blue-700',
    bgColor: 'bg-blue-100',
  },
  reviewer: {
    label: 'Relecteur',
    description: 'Valide et approuve les contenus',
    color: 'text-amber-700',
    bgColor: 'bg-amber-100',
  },
  observer: {
    label: 'Observateur',
    description: 'Accès en lecture seule',
    color: 'text-gray-700',
    bgColor: 'bg-gray-100',
  },
  lot_manager: {
    label: 'Responsable de lot',
    description: 'Gère un lot spécifique',
    color: 'text-green-700',
    bgColor: 'bg-green-100',
  },
};
